export const UPLOADED_IMAGE_MEGABYTE_LIMIT = 50;
